// About USセクションのフェードインアニメーション
document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // About USとCARRERのフェードイン要素を監視
  const fadeElements = document.querySelectorAll('.about-us-fade-in, .carrer-fade-in');
  fadeElements.forEach(element => {
    observer.observe(element);
  });

  // ヘッダードロップダウンのホバー機能（デスクトップのみ）
  if (window.innerWidth >= 992) {
    const dropdownElements = document.querySelectorAll('.navbar .dropdown');

    dropdownElements.forEach(dropdown => {
      dropdown.addEventListener('mouseenter', function() {
        const dropdownMenu = this.querySelector('.dropdown-menu');
        if (dropdownMenu) {
          dropdownMenu.classList.add('show');
        }
      });

      dropdown.addEventListener('mouseleave', function() {
        const dropdownMenu = this.querySelector('.dropdown-menu');
        if (dropdownMenu) {
          dropdownMenu.classList.remove('show');
        }
      });
    });
  }
});

// 採用情報ページ: 追従エントリーCTAの表示制御
// 最下部のエントリーセクションが画面内にある間だけ非表示にする
document.addEventListener('DOMContentLoaded', function() {
  const fixedCta = document.getElementById('job-fixed-cta');
  const entrySection = document.getElementById('job-section-entry');
  if (!fixedCta || !entrySection) return;

  if (!('IntersectionObserver' in window)) {
    fixedCta.classList.add('is-visible');
    return;
  }

  new IntersectionObserver((entries) => {
    fixedCta.classList.toggle('is-visible', !entries[0].isIntersecting);
  }).observe(entrySection);
});
